import { prenatalDefinition, type FlowsheetDefinition } from './definitions';
import { renderedRows } from './renderModel';
import type { ClinicalEvent, ClinicalSubject } from './types';
export function PrenatalCompactCard({
  events,
  subjects,
  encounterId,
  edd = null,
  timeZone,
  definition = prenatalDefinition,
  prePregnancyWeightGrams,
}: {
  events: ClinicalEvent[];
  subjects: ClinicalSubject[];
  encounterId: string;
  edd?: string | null;
  timeZone: string;
  definition?: FlowsheetDefinition;
  prePregnancyWeightGrams?: number | null;
}) {
  const [headers, ...rows] = renderedRows(
    events.filter((e) => e.encounter_id === encounterId),
    subjects,
    timeZone,
    edd,
    definition,
    false,
    prePregnancyWeightGrams,
  );
  return (
    <section aria-label="Prenatal visit summary">
      {!rows.length ? (
        <p>No confirmed observations.</p>
      ) : (
        rows.map((row, i) => (
          <dl key={i} className="grid gap-3 sm:grid-cols-2">
            {headers.map((h, j) => (
              <div key={h}>
                <dt className="text-muted-foreground">{h}</dt>
                <dd className="whitespace-pre-wrap">{row[j]}</dd>
              </div>
            ))}
          </dl>
        ))
      )}
    </section>
  );
}
